module.exports = __webpack_public_path__ + "static/media/10.ee946969.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/10.png
// module id = 862
// module chunks = 0